import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ProSidebarProvider } from 'react-pro-sidebar';
import { ProductContextProvider } from './utils/productContext';
import { Provider } from "react-redux";
import { store } from "./store";
import { I18nextProvider } from 'react-i18next';
import i18n from './language.config';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
    <ProSidebarProvider>
    <ProductContextProvider>
      <App />
    </ProductContextProvider>
    </ProSidebarProvider>
    </I18nextProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
